module.exports = __webpack_public_path__ + "img/bgd4.7252e45f.svg";